/* Redux */
import { useSelector, useDispatch } from 'src/redux/hooks'

/* Types */
import { tItem } from 'src/shared/frontendTypes/warenkorb'

const Redux = () => {
  const dispatch = useDispatch()

  const items = useSelector(store => store.Warenkorb.items)
  const getItem = (key: string) => items[key]

  const addItem = (item:tItem) =>
    dispatch({ type: 'addWarenkorbItem', payload: item })

  return { getItem, addItem }
}

export default Redux
